import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

const Navbar = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleToggleMenu = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleNavLinkClick = (section: any) => {
    setIsMenuActive(false);
    scroller.scrollTo(section, {
      smooth: true,
      offset: -50,
    });
  };

  return (
    <header className={`header ${isMenuActive ? "cloud-active" : ""}`}>
      <nav
        className={`navbar ${isMenuActive ? "active" : ""} ${
          isScrolled && !isMenuActive ? "scrolled" : ""
        }`}
      >
        <Link to="/" className="nav-logo">
          M.
        </Link>
        <ul className={isMenuActive ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-link ${
                location.pathname === "/" ? "active" : ""
              }`}
              onClick={() => handleNavLinkClick("home-section")}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/about"
              className={`nav-link ${
                location.pathname === "/about" ? "active" : ""
              }`}
              onClick={() => handleNavLinkClick("about-section")}
            >
              About
            </Link>
          </li>
          <li className="nav-item">
            <a
              href="#projects-section"
              className={`nav-link ${
                location.pathname === "/about" ? "active" : ""
              }`}
              onClick={() => handleNavLinkClick("projects-section")}
            >
              Projects
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#contact-section"
              className={`nav-link ${
                location.pathname === "/about" ? "active" : ""
              }`}
              onClick={() => handleNavLinkClick("contact-section")}
            >
              Contact
            </a>
          </li>
        </ul>
        <div
          className={isMenuActive ? "hamburger active" : "hamburger"}
          onClick={handleToggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
